import React from 'react'
import DetailTable from 'components/DetailTable'
import ReactDOMServer from 'react-dom/server'
import ShortlistedTemplate from './ShortlistedTemplate'
import RejectedTemplate from './RejectedTemplate'
import IntentToOfferTemplate from './IntentToOfferTemplate'
import RoleUpdateIneligibleTemplate from './RoleUpdateIneligibleTemplate'

const EmailTemplate = ({ data }) => {
  const {
    companyName = '',
    jobTitle = '',
    tableData = {},  
    roleId = '',
    corpId = '',
    signatureName = 'John Doe',
    signatureRole = 'Placement Coordinator',
    signatureInstitute = 'ABC Engineering College',
    signatureContact = '+91 9876543210',
    type = 'create'
  } = data

  const tableContent = ReactDOMServer.renderToString(
    <DetailTable 
      headerName="Job Details" 
      data={tableData} 
    />
  )

  const viewRoleUrl = `${process.env.AUTH_URL}`

  if (type === 'update') {
    return (
      <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
        <p>Dear students,</p>
     
        <p style={{paddingTop:'8px'}}>
          We would like to inform you of an important update regarding the {jobTitle} position at {companyName}, which was previously communicated to you.
        </p>
     
        <p style={{paddingTop:'8px'}}>
          <a href={viewRoleUrl} style={{ color: '#0066cc', textDecoration: 'underline' }}>
            Click here
          </a> to view the updated job description and apply for the role if you have not yet applied.
        </p>
     
        <div dangerouslySetInnerHTML={{ __html: tableContent }} />
   
        <p style={{paddingTop:'10px',paddingBottom:'2px',margin:'0px'}}>Best Regards,</p>
        <p style={{paddingTop:'2px',paddingBottom:'2px',margin:'0px'}}>{signatureName}</p>
        <p style={{paddingTop:'2px',paddingBottom:'2px',margin:'0px'}}>{signatureRole}</p>
        <p style={{paddingTop:'2px',paddingBottom:'2px',margin:'0px'}}>{signatureInstitute}</p>
        <p style={{paddingTop:'2px',paddingBottom:'2px',margin:'0px'}}>{signatureContact}</p>
      </div>
    )
  }

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
      <p>Dear students,</p>
     
      <p style={{paddingTop:'8px'}}>
        We are pleased to inform you about a new job role. {companyName} is looking to fill the role of {jobTitle}.
      </p>
      <p style={{paddingTop:'8px'}}>
          <a href={viewRoleUrl} style={{ color: '#0066cc', textDecoration: 'underline' }}>
            Click here
          </a> to view job description and apply for the role.
        </p>
     
      <div dangerouslySetInnerHTML={{ __html: tableContent }} />
   
      <p style={{paddingTop:'10px',paddingBottom:'2px',margin:'0px'}}>Best Regards,</p>
      <p style={{paddingTop:'2px',paddingBottom:'2px',margin:'0px'}}>{signatureName}</p>
      <p style={{paddingTop:'2px',paddingBottom:'2px',margin:'0px'}}>{signatureRole}</p>
      <p style={{paddingTop:'2px',paddingBottom:'2px',margin:'0px'}}>{signatureInstitute}</p>
      <p style={{paddingTop:'2px',paddingBottom:'2px',margin:'0px'}}>{signatureContact}</p>
    </div>
  )
}

export default EmailTemplate
